/**
 * Deep-merge a partial `override` onto a `base` object, returning a new object (inputs untouched).
 * Plain objects are merged recursively; every other value (strings, numbers, arrays) in `override`
 * replaces the base value. Used to layer a brand's partial dictionary overrides over the bundled one.
 */
function isPlainObject(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v)
}

export function deepMerge<T>(base: T, override: unknown): T {
  if (!isPlainObject(base) || !isPlainObject(override)) {
    // Override wins for leaves / shape mismatches; if override is undefined the base is kept.
    return (override === undefined ? base : (override as T))
  }
  const out: Record<string, unknown> = { ...base }
  for (const key of Object.keys(override)) {
    out[key] = key in base ? deepMerge(base[key], override[key]) : override[key]
  }
  return out as T
}
